// @flow
import React, { Component, Fragment } from 'react';
import SettingSection from 'components/settings/SettingSection/SettingSection';
import SettingProfileContainer from './SettingProfileContainer';
import SettingsEtcContainer from './SettingsEtcContainer';
import SettingEmailContainer from './SettingEmailContainer';
import SettingPasswordContainer from './SettingPasswordContainer';
import SettingProfileLinksContainer from './SettingProfileLinksContainer';

type Props = OwnProps & {
  type: string,
};

class SettingSections extends Component<Props> {
  render() {
    const { type } = this.props;
    return (
      <Fragment>
        {type === 'user' && (
          <SettingSection name="설정">
            <SettingProfileContainer />
          </SettingSection>
        )}
      </Fragment>
    );
  }
}

export default SettingSections;



// WEBPACK FOOTER //
// ./src/containers/settings/SettingSections.js